import React, { createContext, useContext, useEffect, useState } from "react";
import api from "../api";

const StoreContext = createContext(null);

export function StoreProvider({ children }) {
  const [articles, setArticles] = useState([]);
  const [courses, setCourses] = useState([]);
  const [sessions, setSessions] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadAll = async () => {
    try {
      const [a, c, s] = await Promise.all([
        api.get("/articles"),
        api.get("/courses"),
        api.get("/sessions"),
      ]);
      setArticles(a.data);
      setCourses(c.data);
      setSessions(s.data);
    } catch (e) {
      // silent
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadAll();
  }, []);

  const addArticle = async (payload) => {
    const { data } = await api.post("/articles", payload);
    setArticles((prev) => [data, ...prev]);
  };
  const deleteArticle = async (id) => {
    await api.delete(`/articles/${id}`);
    setArticles((prev) => prev.filter((x) => x.id !== id));
  };

  const updateArticle = async (id, payload) => {
    const { data } = await api.put(`/articles/${id}`, payload);
    setArticles((prev) => prev.map((x) => (x.id === id ? data : x)));
  };

  const addCourse = async (payload) => {
    const { data } = await api.post("/courses", payload);
    setCourses((prev) => [data, ...prev]);
  };
  const deleteCourse = async (id) => {
    await api.delete(`/courses/${id}`);
    setCourses((prev) => prev.filter((x) => x.id !== id));
  };

  const updateCourse = async (id, payload) => {
    const { data } = await api.put(`/courses/${id}`, payload);
    setCourses((prev) => prev.map((x) => (x.id === id ? data : x)));
  };

  const addSession = async (payload) => {
    const { data } = await api.post("/sessions", payload);
    setSessions((prev) => [...prev, data]);
  };
  const deleteSession = async (id) => {
    await api.delete(`/sessions/${id}`);
    setSessions((prev) => prev.filter((x) => x.id !== id));
  };

  const value = {
    articles,
    courses,
    sessions,
    loading,
    addArticle,
    deleteArticle,
    updateArticle,
    addCourse,
    deleteCourse,
    updateCourse,
    addSession,
    deleteSession,
  };

  return <StoreContext.Provider value={value}>{children}</StoreContext.Provider>;
}

export function useStore() {
  const ctx = useContext(StoreContext);
  if (!ctx) throw new Error("useStore must be used within StoreProvider");
  return ctx;
}
